export function SET_LANGUAGE(netState, { language }) {
  netState.language = language;
}
